import { render, staticRenderFns } from "./ClassesPolyfill.vue?vue&type=template&id=32fd97c5"
import script from "./ClassesPolyfill.vue?vue&type=script&lang=js"
export * from "./ClassesPolyfill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports